import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type CheckInResponse = {
  date_created: string
  isAssigned: boolean
}

export function useCheckIn() {
  return useMutation({
    mutationFn: async () => {
      const { data } = await apiClient.post<CheckInResponse[]>('/int/v3/dispatcher/checkin')
      return data
    },
  })
}
